import EventHubMixin from '@/mixins/EventHub.js'
import TimeMixin from '@/mixins/Time.js'

export default
{
    name: 'app-loader',

    mixins:
    [
        EventHubMixin,
        TimeMixin
    ],

    data()
    {
        return {
            progress: 0,
            active: false
        }
    },

    created()
    {
        this.total = 0
        this.count = 0
        this.active = false

        this.$eventHub.$on('loader.add', this.add)
        this.$eventHub.$on('loader.remove', this.remove)
    },

    methods:
    {
        add()
        {
            if(!this.active)
            {
                this.count = 0
                this.total = 0
                this.progress = 0
            }

            this.active = true
            this.total++
        },

        remove()
        {
            this.count++

            if(this.count === this.total)
            {
                this.active = false
            }
        },

        onTick()
        {
            let targetProgress = this.count / this.total

            if(targetProgress > 1)
            {
                targetProgress = 1
            }
            if(targetProgress < 0.2)
            {
                targetProgress = 0.2
            }

            this.progress += (targetProgress - this.progress) * this.time.delta * 0.01
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-loader/script.js